module.exports = __webpack_public_path__ + "static/media/schedule.74e85124.jpg";